import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';
import { RegisterUserApi } from '../../../@core/backend/common/api/registerUser.api';
import { InitUserService } from '../../../@theme/services/init-user.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'ngx-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit {

  @Input() user_id;
  @Input() landingPage;
  otp;
  enterOtp;
  private destroy$: Subject<void> = new Subject<void>();
  otpValidation: boolean;

  constructor(protected ref: NbDialogRef<OtpComponent>,
    private api:RegisterUserApi,
    protected initUserService: InitUserService,
    protected router: Router,
    public toasterService: NbToastrService
  ) { }

  ngOnInit() {
    this.api.sendOtp(this.user_id).subscribe(data=>{
      if(data['status'] == 200){
        // this.otp = data['data']
        this.toasterService.success(data['message'], "Success");
      }else{
        this.toasterService.danger(data['message'], "Error");
      }
    })
  }

  cancel(){
    this.ref.close();
    this.router.navigate(['auth/logout']);
  }


  resendOtp(){
    this.api.sendOtp(this.user_id).subscribe(data=>{
      if(data['status'] == 200){
        // this.otp = data['data']
        this.toasterService.success(data['message'], "Success");
      }else{
        this.toasterService.danger(data['message'], "Error");
      }
    })
  }
  verify(){
    this.enterOtp = (document.getElementById('enterOtp') as HTMLInputElement).value;
    this.api.updateOtp(this.user_id,this.enterOtp).subscribe(data=>{
      if(data['status'] == 200){
        if(data['data'].is_otp_verified == 1 || data['data'].is_email_verified == 1){
          this.initUser(data['data'].id,data['data'].user_type,data['data'].email,data['data'].firstname,
          data['data'].lastname,data['data'].mobile,data['data'].is_otp_verified,data['data'].is_email_verified,this.landingPage);
          this.router.navigateByUrl(this.landingPage);
        }else{
          this.otpValidation = false;
        }
      }else{
        this.otpValidation = false;
      }
    })
    // if(this.otp === this.enterOtp){  
               
    // }else{
    //   this.otpValidation = false;
      
    // }
  }

  initUser(id,role,email,firstname,lastname,mobile,is_otp_verified,is_email_verified,landingPage) {
    this.initUserService.initCurrentUser(id,role,email,firstname,lastname,mobile,is_otp_verified,is_email_verified,landingPage)
      .pipe(
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

}
